import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['freezeText', 'rangeType', 'rangeTypeDropdown', 'unlockText']

  toggleFreezeText(event) {
    if (event.srcElement.name === 'freeze_range_age') {
      if (this.freezeTextTarget.style.display === 'none') {
        this.freezeTextTarget.style.display = 'block';
        this.rangeTypeTarget.style.display = 'none';
        this.rangeTypeDropdownTarget.style.display = 'block';
      } else {
        this.freezeTextTarget.style.display = 'none';
        this.rangeTypeTarget.style.display = 'block';
        this.rangeTypeDropdownTarget.style.display = 'none';
      }
    } else {
      if (event.srcElement.checked) {
        this.unlockTextTarget.style.display = 'block';
      } else {
        this.unlockTextTarget.style.display = 'none';
      }
    }
  }
}
